import React from "react";
import './detailpage.scss';
import Dropdown from 'react-bootstrap/Dropdown';
import "./shoppingcart.scss";
import PaypalCheckoutBtn from '../components/paypal';

var bill_total = 0

class ShoppingCart extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           shipmentFee:30,
           shipmentArea:"North / South America",
        }
      }

componentDidMount(){
   

   
}

  render(){
    if(this.props.shoppingCart != (null||undefined)){
      bill_total = 0
      for(var k in this.props.shoppingCart){
        bill_total = bill_total + parseInt(this.props.shoppingCart[k]["unit_price"])*parseInt(this.props.shoppingCart[k]["quantity"])
      }
      //bill_total = bill_total + this.state.shipmentFee
    }
   
    

    return (
      <div className="shoppingcart-main">

        <div className={"shoppingcart-left"}>
        
            <div className={"shoppingcart-tabletitle"}>{"Your Shopping Cart (all in USD)"}</div>

            <table className={"shoppingcart-table"}>
              <thead>
                  <tr>
                      <th style={{width:"3%"}}>&nbsp;</th>
                      <th style={{width:"25%"}}>Item Name</th>
                      <th style={{width:"30%"}}>Options</th>
                      <th style={{width:"8%"}}>Quantity</th>
                      <th style={{width:"8%"}}>Unit Price</th>
                      <th style={{width:"8%"}}>10% Discount</th>
                      <th style={{width:"9%"}}>Net Unit Price</th>
                      <th style={{width:"8%"}}></th>
                  </tr>
                </thead>


                <tbody>
                {   (this.props.shoppingCart != (null||undefined)) &&
                    Object.keys(this.props.shoppingCart).map((i)=>{
                        var op = this.props.shoppingCart[i]["options"]
                        var op_string = ""
                        for (var jj in op){
                          op_string = op_string + jj + " - " + op[jj] + ", \n\r "
                        }
                          op_string = op_string.slice(0,-5)
                      return(
                   
                            <tr>
                                <td style={{width:"3%"}}>
                                  <img src={"/assets/"+this.props.shoppingCart[i]["cat"]+"-"+this.props.shoppingCart[i]["item"]+"-1.PNG"} width="100px" alt="product img" />
                                </td>
                                <td style={{width:"25%"}}>{this.props.shoppingCart[i]["name"]}</td>
                                <td style={{width:"30%"}}>{op_string}</td>

                                <td className={"shoppingCart-td-quantity"}>  
                                  <div onClick={(e)=>{
                                    var qty = this.props.shoppingCart
                                    if (qty[i]["quantity"]  >= 2){
                                      qty[i]["quantity"]  = qty[i]["quantity"] - 1
                                    }
                                    this.props.setval({shoppingCart:qty})
                                  }}><img className="shoppingCart-qty" src={"/assets/minus.svg"} width="20px" alt="-"/></div>
                                      <div style={{minWidth:"30px"}}>{this.props.shoppingCart[i]["quantity"]}</div>
                                  <div onClick={(e)=>{
                                    var qty = this.props.shoppingCart
                                    if (qty[i]["quantity"]  >= 1){
                                      qty[i]["quantity"]  = qty[i]["quantity"] + 1
                                    }
                                    this.props.setval({shoppingCart:qty})
                                  }}> <img className="shoppingCart-qty" src={"/assets/plus.svg"} width="20px" alt="+"/></div>
                                </td>
        
                                <td style={{width:"6%"}}>{this.props.shoppingCart[i]["unit_price"]}</td>
                                <td style={{width:"8%"}}>{Math.round(this.props.shoppingCart[i]["unit_price"]*.1*10)/10}</td>
                                <td style={{width:"9%"}}>{Math.round(this.props.shoppingCart[i]["unit_price"]*.9*10)/10}</td>
                                <td style={{width:"8%"}} onClick={(e)=>{
                                  var cart = this.props.shoppingCart
                                  delete cart[i]
                                  this.props.setval({shoppingCart:cart})
                                }}>
                                  <img className="shoppingCart-del" src={"/assets/x.svg"} width="20px" alt="DELETE" />
                                </td>
                               
                            </tr>
                    
                      )
                    })
                }

                </tbody>
                </table>

                <div style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center",fontWeight:"800"}}>
                <div style={{width:"63%"}}>&nbsp;</div>
                  <div style={{width:"20%",fontSize:"1.6em",fontWeight:"700"}}>{"Total (USD)"} </div>
                  <div style={{width:"10%",fontSize:"1.6em",fontWeight:"700"}}>{Math.round(bill_total*0.9*10)/10} </div>
                  <div style={{width:"7%"}}>&nbsp; </div>

                </div>

                {/* <tr>
                    <td style={{width:"5%"}}>&nbsp;</td>
                    <td style={{width:"10%"}}></td>
                    <td style={{width:"10%"}}></td>
                    <td style={{width:"15%"}}></td>
                    <td style={{width:"20%"}}></td>
                    <td style={{width:"30%"}}>{"Total (USD)"}</td>
                    <td style={{width:"100%"}}>{bill_total} </td>
                </tr> */}

                {/* <tr>
                    <th style={{width:"5%"}}>&nbsp;</th>
                    <th style={{width:"35%"}}></th>
                    <th style={{width:"20%"}}></th>
                    <th style={{width:"20%"}}>{"Opening Discount USD (15% off)"}</th>
                    <th style={{width:"20%"}}>{-1*Math.round(bill_total*0.15)} </th>
                </tr>

                <tr>
                    <th style={{width:"5%"}}>&nbsp;</th>
                    <th style={{width:"35%"}}></th>
                    <th style={{width:"20%"}}></th>
                    <th style={{width:"20%"}}>{"Payment Due (USD)"}</th>
                    <th style={{width:"20%"}}>{Math.round(bill_total*0.85)} </th>
                </tr> */}



           
        </div>

        <div className={"shoppingcart-right"}>
                {/* <div className={"shoppingcart-optionbar"}>
                    <div className={"shoppingcart-optionbar-item"}>{"Shipment Area"+ " [ Cost (USD): "+this.state.shipmentFee+" ]"}</div>
                    <Dropdown>
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        {this.state.shipmentArea }
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={(e)=>{
                          this.setState({shipmentFee:20,shipmentArea:"Asia"})
                        }}>Asia</Dropdown.Item>
                         <Dropdown.Item onClick={(e)=>{
                          this.setState({shipmentFee:25,shipmentArea:"Europe / Africa"})
                        }}>Europe / Africa</Dropdown.Item> <Dropdown.Item onClick={(e)=>{
                          this.setState({shipmentFee:30,shipmentArea:"North / South America"})
                        }}>North America / South America </Dropdown.Item>
                         <Dropdown.Item onClick={(e)=>{
                           this.setState({shipmentFee:25,shipmentArea:"Oceania"})
                        }}>Oceania</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                </div> */}
                <div className={"shoppingcart-optionbar"}>
                  <div className={"shoppingcart-tabletitle"}>{"Proceed to checkout here"}</div>
                  <PaypalCheckoutBtn {...this.state} billTotal={bill_total} shoppingCart={this.props.shoppingCart} setval={this.props.setval} />
                </div>
                
            </div>

      </div>
    );


  }
}

export default ShoppingCart;
